import listHandler from "@serie3/common/Domain/listHandler";

const addElement = (formik, dataReference, valueName, dontSend = false) => {
  if (typeof dataReference === "undefined" || dataReference.current.value === "") return;

  const names = dataReference.current.value
    .split(",")
    .map((s) => s.trim())
    .filter((s) => s !== "");

  names.forEach((name) => {
    formik.values[valueName].push({ name });
  });

  if (dontSend !== true) {
    formik.handleSubmit();
  }
  dataReference.current.value = "";
};

const deleteElement = (namedElement, valueName, setDataList, formik, dontSend = false) => {
  const itemIndex = formik.values[valueName].findIndex(
    (obj) => obj.id === namedElement.id
  );
  listHandler.deleteFromList(
    itemIndex,
    undefined,
    setDataList,
    formik.values[valueName],
    null
  );

  if(dontSend !== true){
    formik.handleSubmit();
  }
};

export default { addElement, deleteElement };
